import { createContext, useContext } from 'react';

const AnalyticsContext = createContext();

export const useAnalyticsContext = () => useContext(AnalyticsContext);
export default AnalyticsContext;
